import React, { useCallback, useEffect, useState } from 'react';
import { IonContent, IonSearchbar, IonGrid, IonRow, IonCol } from '@ionic/react'

import { IVideoYoutube } from '../models/IVideoYoutube';

import { searchVideos } from '../services/YoutubeService';

import ItemVideo from './ItemVideo';

export interface Props {
  initialSearchTerm?: string
  onSelect: (item: IVideoYoutube) => any
}

const SearchVideo: React.FC<Props> = ({ initialSearchTerm, onSelect }) => {
  const [termSearch, setTermSearch] = useState('')
  const [videos, setVideos] = useState<IVideoYoutube[]>([])
  const [loading, setLoading] = useState(false)

  const searchByTerm = useCallback(async (term?: string) => {
    setLoading(true)

    try {
      const termFormatted = termSearch.trim()

      if (termFormatted) {
        const videos = await searchVideos(termFormatted)
        setVideos(videos)
      }
    } catch (error) {
      setVideos([])
    }

    setLoading(false)
  }, [termSearch])

  useEffect(() => {
    setTermSearch(initialSearchTerm ?? '')
  }, [initialSearchTerm])

  useEffect(() => {
    searchByTerm(termSearch)
  }, [searchByTerm, termSearch])

  return (
    <IonContent>
      <IonGrid fixed={true}>
        <IonRow className="ion-align-items-center">
          <IonCol>
            <IonSearchbar placeholder="Qual video do Youtube demostra o uso?" value={termSearch} onIonChange={e => setTermSearch(e.detail.value ?? '') } />
          </IonCol>
        </IonRow>

        <IonRow className="ion-align-items-center">
          {!loading && videos.map((video, index) =>
            <IonCol size="6" sizeXs="12" sizeSm="12" sizeMd="6" className="ion-justify-content-center" key={index}>
              <ItemVideo item={video} onClick={() => onSelect(video)} />
            </IonCol>
          )}
        </IonRow>
      </IonGrid>
    </IonContent>
  )
}

export default SearchVideo
